import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftThanksPageComponent } from './gift-thanks-page.component';
import { ContentModule } from './components/content/content.module';
import { HeaderModule } from '../order-page/components/header/header.module';
import { FooterModule } from '../order-page/components/footer/footer.module';

@NgModule({
  declarations: [GiftThanksPageComponent],
  imports: [CommonModule, FooterModule, HeaderModule, ContentModule],
})
export class GiftThanksPageModule {}
